import { render } from "./ks-heading.vue?vue&type=template&id=1a05d868"
import script from "./ks-heading.vue?vue&type=script&lang=js"
export * from "./ks-heading.vue?vue&type=script&lang=js"

import "./ks-heading.vue?vue&type=style&index=0&id=1a05d868&lang=css"
script.render = render

export default script